import { RoomTypes } from '~analytics/types';

import { sendLaunchVoteEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class LaunchVoteEventAdapter extends EventAdapter {
  protected intercomEventKey = 'launch-vote';
  protected amplitudeEventFunction = sendLaunchVoteEvent;

  constructor(isRosteredRoom: boolean) {
    super();

    try {
      const roomType = isRosteredRoom
        ? RoomTypes.RosteredRoom
        : RoomTypes.OpenRoom;
      this.eventData = {
        room_type: roomType,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
